export const PRE_LIVE_CLASS = "pre-liveclass";
export const POST_LIVE_CLASS = "post-liveclass";

export const NEWS_FREAD = "news";
export const ACTIVITY = "activity";
export const STORY = "story";

export const READ_ALONG_STORY = "read_along_story";
export const QUIZ = "quiz";
export const WORD_GAME = "wordgame";
export const PICTIONARY = "pictionary";
export const READ_TO_ME = "read_to_me";
export const READ_AND_SPEAK = "read_and_speak";
export const NEWS_FREAD_GLOBAL_SEARCH = "news_fread";

// content_sub_type values sent to the guided-path task API
export const CONTENT_SUB_TYPE_READ_AND_SPEAK = "read_and_speak";
export const CONTENT_SUB_TYPE_READ_TO_ME = "read_to_me";

export const GRAMMAR = "GRAMMAR";
export const READING = "READING";
export const LISTENING = "LISTENING";
export const SPELLING = "SPELLING";

export const EASY = "easy";
export const MEDIUM = "medium";
export const HARD = "hard";

export const WORD_GAME_NAME = "Word Game";
export const WORD_GAME_DESCRIPTION = "Difficulty level";
export const WORD_GAME_THUMBNAIL =
  "https://freadom-beta-bucket.s3.amazonaws.com/1782133042.52-wordgame_task.webp";

export const PICTIONARY_NAME = "Pictionary";
export const PICTIONARY_DESCRIPTION = "Difficulty level";
export const PICTIONARY_THUMBNAIL =
  "https://freadom-beta-bucket.s3.amazonaws.com/1782133088.22-pictionary_task.webp";

export const GRADE_LEVEL_MAPPING = {
  "Level 1": "Montessori",
  "Level 2": "Nursery",
  "Level 3": "Kindergarten",
  "Level 4": "Grade 1",
  "Level 5": "Grade 2",
  "Level 6": "Grade 3",
  "Level 7": "Grade 4",
  "Level 8": "Grade 5",
  "Level 9": "Grade 6",
  "Level 10": "Grade 7",
  "Level 11": "Grade 8"
};

export const READER_TYPES = [
  {
    label: "Emergent Reader",
    value: "Emergent Reader"
  },
  {
    label: "Intermediate Reader",
    value: "Intermediate Reader"
  },
  {
    label: "Advanced Reader",
    value: "Advanced Reader"
  },
  {
    label: "No Reader Level",
    value: "No Reader Level"
  }
];

export const ACADEMIC_YEAR_START = "04-01-2024";
export const ACADEMIC_YEAR_END = "2025-03-31";
export const CAMBRIDGE_SCHOOLS = ["epbrpe", "ccviou", "hlxfxj", "geqtcw", "rmcjhc"];
export const IRO_GRADES = ["Grade 2", "Grade 3", "Grade 4", "Grade 5", "Grade 6"];
export const MOCK_ASSESSMENT_ID = "6a38e898-61c2-4fac-9d36-8587fac6aa5a";
